import { Inject, Injectable } from '@angular/core';
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwEventService, 
         DwCacheService, DwQueryFilter, DwQueryHelper, DwOrmData } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataService, EthosWachterDepartmentEntity } from '../../../meta-data/app-meta-data.service';
import { CodeValuePermitType, PermitsV2MetaDataService } from '../../permits/meta-data/permitsv2-meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class PermitV2RequestService {

  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dwEventsService: DwEventService,
    private dwCacheService: DwCacheService,
  ) { }

  // getPermitTypeName(type: number) {
  //   return  type == CodeValuePermitType.DataVoice ? "Voice & Data" :
  //           type == CodeValuePermitType.CCTV ? "CCTV" :
  //           type == CodeValuePermitType.AudioVisual ? "Audio/Visual" :
  //           type == CodeValuePermitType.FireAlarm ? "Fire Alarm" :
  //           type == CodeValuePermitType.Electrical ? "Electrical" :
  //           type == CodeValuePermitType.AccessControl ? "Access Control" :
  //           type == CodeValuePermitType.BurglarAlarm ? "Burglar Alarm" : "";
  // }

  getWachterDivisionId(wachterDeparmentId: number): Observable<number> {

    return this.getWachterDepartments()
      .pipe(map(departments => {
        return departments.find(d => d.WachterDepartmentId == wachterDeparmentId)?.WachterDivisionId;
      }))
  }

  getWachterDepartments() : Observable<EthosWachterDepartmentEntity[]> {
    return this.dwCacheService.getWithOptions("wachterDepartments", this.loadWachterDepartments());
  }


  private loadWachterDepartments(): Observable<EthosWachterDepartmentEntity[]> {
    const md = new AppMetaDataService();
    var qh = new DwQueryHelper();

    const query = md.EthosWachterDepartment.CreateQuery();

    query.FieldSettings.IncludeRootItemFields = false;
    query.FieldSettings.LoadAllLookupDisplayFields = true;

    query.AddField(md.EthosWachterDepartment.WachterDivisionId);
    
    query.AddField(md.EthosWachterDepartment.WachterDepartmentId);

    return this.dwOrmDataService.executeQuery(query);
  }
}
